import request from '@/router/axios'

// 修改报名信息
export function ModifyTestApplication(query) {
    return request({
        url: '/api/services/app/TestApplication/ModifyTestApplication',
        method: 'post',
        data: query
    })
}

// 首页-测试机构列表
export function GetTestMechListIndex(query) {
    return request({
        url: '/api/services/app/TestMechanism/GetTestMechListIndex',
        method: 'post',
        data: query
    })
}

// 首页-考评员列表
export function GetUserCoachListIndex(query) {
    return request({
        url: '/api/services/app/UserCoachApi/GetUserCoachListIndex',
        method: 'post',
        data: query
    })
}
